import { Accordion, Button, Col, Container, Dropdown, Row } from "react-bootstrap";
import { formatDate } from "../../../../Utils/Common";
import DetailItem from "../DataItem";
import CollectSampleNote from "./CollectSampleNote";
import { Fragment, useEffect, useState } from "react";
import DonorDemographicsList from "./DonorDemographicsList";
import HealthDataDownloadButton from "./HealthDataDownloadButton";
const StoolAccordion = ({ id, sampleRequestDetails, recruitedDonor, isCollectSample ,isMatched,selectedRecruitedDonor, collectSample, type, raceList  }) => {
    const [collectSampleNote, setCollectSampleNote]=useState("");
    const [isCollect, setIsCollect]=useState(false);
 
    useEffect(()=>{
        if(isCollect){              

            const collectSamplePayload = { 
                sample_id : id,
                collection_note : collectSampleNote, 
            }

            collectSample(collectSamplePayload);
            setIsCollect(false);
        }
    },[isCollect]);

    useEffect(() => {
        if (selectedRecruitedDonor) { 
            const donatedSamplesArray = selectedRecruitedDonor?.donated_samples
                ?.split(',')
                .map((sample) => sample.trim()); // Split and trim whitespace
    
            if (donatedSamplesArray?.includes(id.toString())) { 
                // setCollectSampleNote(selectedRecruitedDonor?.collected_notes);
                const notesArray = selectedRecruitedDonor?.collected_notes?.split(',').map((note) => note.trim());
                const noteIndex = selectedRecruitedDonor?.donated_samples
                    ?.split(',')
                    .map((sample) => sample.trim())
                    .indexOf(id.toString());
                    if(notesArray){
                        setCollectSampleNote(noteIndex !== -1 ? notesArray[noteIndex] : "");
                    }
            }
            else{
                setCollectSampleNote("");
            }
        }
        else{
            setCollectSampleNote("");
        }
    }, [selectedRecruitedDonor, id]);
    return (
        // <Accordion className="accordion-item" flush>
        <Accordion.Item eventKey="16">
            <Accordion.Header>
                <div className="text-white el-sample-btn bg-stool rounded p-2 btn">
                    <i className="el-icon-stool me-2"></i> Stool
                </div>
                
                {
                    selectedRecruitedDonor?.donated_samples
                        ?.split(',')
                        .map((sample) => sample.trim())
                        .includes(id.toString()) && (
                        <>
                            <div className="text-white bg-success el-sample-btn btn rounded p-2 ms-2">
                                <i className="el-icon-check"></i> Collected
                            </div>
                        </>
                    )
                }
            </Accordion.Header>
            <Accordion.Body>
                <div className="el-property-details-card-content">
                    <Row>
                        <Col md={12} className="mx-fit-content">
                            <div className="flex-sec justify-content-between align-items-start">

                                {/* Sample Expiration Date */}

                                <DetailItem
                                    title="Sample’s Expiration Date"
                                    detail={formatDate(
                                        sampleRequestDetails.expiration_date || ''
                                    )}
                                />
                                {/* Sample can remain unprocessed */}
                                <DetailItem
                                    title="Sample can remain unprocessed"
                                    detail={
                                        `${sampleRequestDetails.unprocess_number} - ${sampleRequestDetails.unprocess_unit[0].toUpperCase() + sampleRequestDetails.unprocess_unit.slice(1)}` || ''
                                    }
                                />



                                {/* Is Fasting Required */}
                                <DetailItem
                                    title="Is Fasting Required?"
                                    detail={
                                        sampleRequestDetails?.is_fasting === 1
                                            ? `Yes - ${sampleRequestDetails?.fasting_duration || ''} ${sampleRequestDetails?.fasting_unit ? (sampleRequestDetails.fasting_unit[0].toUpperCase() + sampleRequestDetails.fasting_unit.slice(1)) : ''}`
                                            : 'No'
                                    }
                                />
                                {/* Sample Type(s) */}
                                <DetailItem
                                    title="Sample Type(s)"
                                    detail={sampleRequestDetails.samples_info.map((tube, index) => (
                                        tube.field_value ? (
                                            <p key={index} className="el-request-detail-profile-name"> {`Amount of Sample Required per Volunteer (g) - ${tube.field_value} g`} </p>
                                        ) : null
                                    ))}
                                />
                                {/* Donor ID */}
                                {!isCollectSample && (
                                            <>
                                <div className="el-flex-area mb-3">
                                    <div className="el-content-detail">
                                        <DetailItem
                                            title="Special Donor Requests" 
                                            detail= {sampleRequestDetails.is_special_donor == 1 ? 'Yes' : 'No'}
                                        />
                                        {/* <p className="el-request-detail-profile-title">
                                            Special Donor Requests:
                                        </p>
                                        <h4 className="el-request-detail-profile-name">
                                            {sampleRequestDetails.is_special_donor == 1 ? 'Yes' : 'No'}
                                        </h4> */}
                                        {sampleRequestDetails.is_special_donor == 1 && (<>  <p className="el-request-detail-profile-title">
                                            Preferred donor ID:
                                        </p>
                                            <h4 className="el-request-detail-profile-name">

                                                {/* {JSON.parse(sampleRequestDetails.special_donor_ids)?.map((donor, index) => (<p>{index + 1}. Donor ID: {donor} </p>))} */}
                                                {JSON.parse(sampleRequestDetails.special_donor_ids)?.map(
                                                    (donor, index) => (
                                                        <p key={index}>
                                                            {/* {index + 1}. Donor ID: {donor} */}
                                                            {index + 1}. Donor ID: {donor}, { sampleRequestDetails.special_donor_ids_gender[index]}
                                                        </p>
                                                    )
                                                )}
                                                {/* {JSON.parse(sampleRequestDetails.special_donor_gender)?.map((donor, index) => (<p>{JSON.parse(sampleRequestDetails.special_donor_ids).length + index + 1}.  Donor ID: {donor}, {JSON.parse(sampleRequestDetails.special_donor_gender)[index] === 'XX' ?
                                                    `Female (${JSON.parse(sampleRequestDetails.special_donor_gender_quantity)[index]})` :
                                                    `Male (${JSON.parse(sampleRequestDetails.special_donor_gender_quantity)[index]})`}  </p>))} */}
                                                {JSON.parse(sampleRequestDetails.special_donor_gender)?.map((donor, index) => (
                                                    <p key={index}>
                                                        {(JSON.parse(sampleRequestDetails.special_donor_ids)?.length || 0) + index + 1}. Donor ID: {donor},{" "}
                                                        {JSON.parse(sampleRequestDetails.special_donor_gender)[index] === "XX"
                                                            ? `Female (${JSON.parse(sampleRequestDetails.special_donor_gender_quantity)[index]})`
                                                            : `Male (${JSON.parse(sampleRequestDetails.special_donor_gender_quantity)[index]})`}
                                                    </p>
                                                ))}
                                            </h4>
                                            <DonorDemographicsList
                                            sampleRequestDemographics={sampleRequestDetails.sample_request_demographics}
                                            raceList={raceList}
                                            />
                                            <p className="el-request-detail-profile-title">
                                                Alternate Donor ID:
                                            </p>
                                            {/* <h4 className="el-request-detail-profile-name">
                                                {JSON.parse(sampleRequestDetails.alternate_donor_ids)?.map(
                                                    (donor, index) => (
                                                        <p key={index}>
                                                            {index + 1}. Donor ID: {donor}, {sampleRequestDetails.alternate_donor_ids_gender[index] }

                                                        </p>
                                                    )
                                                )}
                                              
                                                {JSON.parse(sampleRequestDetails.alternate_donor_gender)?.map((donor, index) => (
                                                    <p key={index}>
                                                        {(JSON.parse(sampleRequestDetails.alternate_donor_ids)?.length || 0) + index + 1}. Donor ID: {donor},{" "}
                                                        {JSON.parse(sampleRequestDetails.alternate_donor_gender)[index] === "XX"
                                                            ? `Female (${JSON.parse(sampleRequestDetails.alternate_donor_gender_quantity)[index]})`
                                                            : `Male (${JSON.parse(sampleRequestDetails.alternate_donor_gender_quantity)[index]})`}
                                                    </p>
                                                ))}
                                            </h4> */}
                                        </>)}
                                        {/* <p className="el-request-detail-profile-title">
                                            Recruited Donor ID:
                                        </p>
                                        <h4 className="el-request-detail-profile-name">
                                        </h4> */}
                                    </div>
                                </div>
                                </>)}
                                {/* Special Instructions */}
                                {/* <div className="el-flex-area mb-3  ">
                                    <div className="el-content-detail">
                                        <p className="el-request-detail-profile-title">
                                            Special Instructions :
                                        </p>
                                        <h4 className="el-request-detail-profile-name">
                                            {sampleRequestDetails.instruction || '-'}
                                        </h4>
                                    </div>
                                </div> */}
                                <DetailItem
                                    title="Special Instructions"
                                    detail={sampleRequestDetails.instruction || '-'}
                                /> 
                                {!isCollectSample && type !== 'requestor' && recruitedDonor?.length > 0 && !isMatched &&(
                                    <>
                                        <DetailItem
                                            title="Recruited Donors"
                                        />
                                        <h4 className="el-request-detail-profile-name">
                                            {recruitedDonor.map((donorItem, index) => (
                                                <div key={index}>
                                                    {`${index + 1}. Donor ID: ${donorItem.donor.donor_id}. ${donorItem.donor.gender === 'XY' ? 'Male' : 'Female'} (${donorItem.donor.gender})`}
                                                    <HealthDataDownloadButton requestId={sampleRequestDetails.request_id} donorId={donorItem.donor.id}></HealthDataDownloadButton>
                                                    
                                                </div>
                                            ))}
                                        </h4>
                                    </>
                                )}


                                
                                {isCollectSample === true && (
                                <>
                                  {selectedRecruitedDonor && (
                                    <CollectSampleNote collectSampleNote={collectSampleNote} setCollectSampleNote={setCollectSampleNote} isCollect={isCollect} setIsCollect={setIsCollect}  selectedRecruitedDonor={selectedRecruitedDonor} id={id}/>
                                  )}
                                </>
                                )} 
                            </div>
                        </Col>
                    </Row>
                </div>
            </Accordion.Body>
        </Accordion.Item>
        // </Accordion>
    );
};

export default StoolAccordion